// GTM helpers, copied from Quincy

export function getKrux() {
  if (typeof window === 'undefined') {
    // not client side, ignore
    return () => {};
  }

  // prettier-ignore
  const krux = window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]); //eslint-disable-line
  return krux;
}

// from https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder#Polyfill
/* eslint-disable */
export function textEncodePolyfill(str) {
  var Len = str.length,
    resPos = -1;
  // The Uint8Array's length must be at least 3x the length of the string because an invalid UTF-16
  //  takes up the equivelent space of 3 UTF-8 characters to encode it properly. However, Array's
  //  have an auto expanding length and 1.5x should be just the right balance for most uses.
  var resArr = typeof Uint8Array === 'undefined' ? new Array(Len * 1.5) : new Uint8Array(Len * 3);
  for (var point = 0, nextcode = 0, i = 0; i !== Len; ) {
    (point = str.charCodeAt(i)), (i += 1);
    if (point >= 0xd800 && point <= 0xdbff) {
      if (i === Len) {
        resArr[(resPos += 1)] = 0xef /*0b11101111*/;
        resArr[(resPos += 1)] = 0xbf /*0b10111111*/;
        resArr[(resPos += 1)] = 0xbd /*0b10111101*/;
        break;
      }
      // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      nextcode = str.charCodeAt(i);
      if (nextcode >= 0xdc00 && nextcode <= 0xdfff) {
        point = (point - 0xd800) * 0x400 + nextcode - 0xdc00 + 0x10000;
        i += 1;
        if (point > 0xffff) {
          resArr[(resPos += 1)] = (0x1e /*0b11110*/ << 3) | (point >>> 18);
          resArr[(resPos += 1)] = (0x2 /*0b10*/ << 6) | ((point >>> 12) & 0x3f) /*0b00111111*/;
          resArr[(resPos += 1)] = (0x2 /*0b10*/ << 6) | ((point >>> 6) & 0x3f) /*0b00111111*/;
          resArr[(resPos += 1)] = (0x2 /*0b10*/ << 6) | (point & 0x3f) /*0b00111111*/;
          continue;
        }
      } else {
        resArr[(resPos += 1)] = 0xef /*0b11101111*/;
        resArr[(resPos += 1)] = 0xbf /*0b10111111*/;
        resArr[(resPos += 1)] = 0xbd /*0b10111101*/;
        continue;
      }
    }
    if (point <= 0x007f) {
      resArr[(resPos += 1)] = (0x0 /*0b0*/ << 7) | point;
    } else if (point <= 0x07ff) {
      resArr[(resPos += 1)] = (0x6 /*0b110*/ << 5) | (point >>> 6);
      resArr[(resPos += 1)] = (0x2 /*0b10*/ << 6) | (point & 0x3f) /*0b00111111*/;
    } else {
      resArr[(resPos += 1)] = (0xe /*0b1110*/ << 4) | (point >>> 12);
      resArr[(resPos += 1)] = (0x2 /*0b10*/ << 6) | ((point >>> 6) & 0x3f) /*0b00111111*/;
      resArr[(resPos += 1)] = (0x2 /*0b10*/ << 6) | (point & 0x3f) /*0b00111111*/;
    }
  }
  if (typeof Uint8Array !== 'undefined') return resArr.subarray(0, resPos + 1);
  // else // IE 6-9
  resArr.length = resPos + 1; // trim off extra weight
  return resArr;
}
/* eslint-enable */

function textEncode(str) {
  // TextEncoder not available in IE, Edge and Safari 9
  if (window.TextEncoder) {
    return new TextEncoder().encode(str);
  }
  return textEncodePolyfill(str);
}

function hex(hashBuffer) {
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  // convert bytes to hex string
  const hashHex = hashArray.map(byte => `00${byte.toString(16)}`.slice(-2)).join('');
  return hashHex;
}

export async function sha256(message) {
  if (typeof window !== 'object') {
    return Promise.reject('Not intended for server side');
  }
  const msgBuffer = textEncode(message);

  try {
    if (window.crypto) {
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);
      const hashHex = hex(hashBuffer);
      return hashHex;
    } else if (window.msCrypto) {
      // eslint-disable-next-line
      const promise = new Promise((resolve, reject) => {
        const cryptoOperation = window.msCrypto.subtle.digest('SHA-256', msgBuffer);
        cryptoOperation.oncomplete = () => {
          const hashHex = hex(cryptoOperation.result);
          resolve(hashHex);
        };
        cryptoOperation.onerror = () => {
          reject('error in sha-256 digest');
        };
      });
      return promise;
    }
  } catch (error) {
    return Promise.reject('Browser does not support crypto.subtle digest API');
  }
}
